import React, { useState, useEffect } from 'react';
import { getWorksReadingHistory } from 'js/social/api/works_reading_history_api';
import { WorkWithMetadata } from './shared/types';
import { ContinueReadingWorkCard } from './ContinueReadingWorkCard';
import SuggestedContentSidebar from './shared/SuggestedContentSidebar';
import { getSocialImpressionSource } from './ImpressionHelper';
import { Skeleton } from 'js/design_system/skeleton/Skeleton';

type Props = {
  className?: string;
};

const IMPRESSION_PAGE = 'home';
const IMPRESSION_SECTION = 'read';

export const ContinueReading: React.FC<Props> = ({ className }) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [works, setWorks] = useState<WorkWithMetadata[]>([]);

  useEffect(() => {
    getWorksReadingHistory()
      .then(({ worksWithMetadata: works }) => {
        const normalizedWorks = Object.keys(works)
          .map(Number)
          .sort((id1, id2) => works[id1].index - works[id2].index)
          .map((id) => ({ ...works[id], id }));
        setWorks(normalizedWorks);
        setLoading(false);
      })
      .catch(() => setError(true));
  }, []);

  if (error || (works.length <= 0 && !loading)) {
    return null;
  }

  return (
    <SuggestedContentSidebar
      viewAllUrl="/ReadingHistory"
      headerText="Continue Reading"
      className={className}
      impressionSource={getSocialImpressionSource(
        IMPRESSION_PAGE,
        IMPRESSION_SECTION,
        'history',
      )}
    >
      {loading
        ? [...Array(4)].map((_, idx) => (
            <Skeleton key={idx} type="continue-reading" />
          ))
        : works
            .slice(0, 4)
            .map((work) => (
              <ContinueReadingWorkCard key={work.id} work={work} />
            ))}
    </SuggestedContentSidebar>
  );
};
